'use strict';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'encodeURIComponent'})
export class EncodeURIComponentPipe implements PipeTransform {
    transform(secName: string): string {
        if (typeof secName === 'string' || (<any>secName) instanceof String) {
            return secName;
        }
        return encodeURIComponent(secName);
    }
}



// WEBPACK FOOTER //
// ./_src/ui/elements/encodeURIComponentPipe.ts